import { render, staticRenderFns } from "./Monedero.vue?vue&type=template&id=03219196"
import script from "./Monedero.vue?vue&type=script&lang=js"
export * from "./Monedero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports